const pageCategoryViewSettings = () => {
    const productsList = document.getElementById('products');
    const products = document.querySelectorAll('.product');
    const productsListBaseClass = 'page-category__products-list';
    const viewControls = document.querySelectorAll('.page-category__view-control');
    if (!productsList) return false;
    if (!viewControls) return false;
    let savedView = localStorage.getItem('savedView');
    if (!savedView) {
        savedView = '--grid-view';
    };
    const setCurrentView = () => {
        viewControls.forEach((el) => {
            el.classList.remove('--is-active');
            if (el.classList.contains(savedView)) {
                el.classList.add('--is-active');
            }
        });
        productsList.classList = `${productsListBaseClass} ${savedView}`;
    }
    setCurrentView();
    viewControls.forEach((el) => {
        el.addEventListener('click', () => {
            savedView = el.dataset.viewType;
            localStorage.setItem('savedView', savedView);
            setCurrentView();
        });
    });
}

export default pageCategoryViewSettings;
